<template>
    <div class="h-100 w-100">
        <c-site-contract-flip-card
            v-if      = "contractValid"
            :title    = "$t('contract.esc.title')"
            :contract = "contract"
            :edit     = "true"
            :unit     = "unit"
            @readonly = "onReadonly"
            @store    = "onStore"
        >
            <template v-slot:front>
                <f-title
                    class  = "mt-3"
                    :title = "$t('contract.terms')"
                />

                <v-row class="no-frame mb-2">
                    <v-col class="no-frame">
                        <f-enum-select-rw
                            v-model       = "contract.unit.gadget"
                            :label        = "$t('contract.esc.gadgetRent')"
                            :readonly     = "readonly"
                            module        = "msd"
                            type          = "escGadgetRentType"
                            :hide-details = "true"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame mb-2">
                    <v-col class="no-frame pr-2">
                        <f-currency-field-rw
                            :label    = "$t('contract.esc.costs')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.costs"
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                    </v-col>
                </v-row>

                <v-row class="no-frame mb-2">
                    <v-col class="no-frame pr-2">
                        <f-currency-field-rw
                            :label    = "$t('contract.esc.rentPerYear')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.rent"
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                        <f-currency-field-rw
                            :label    = "$t('contract.esc.standByPerYear')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.standBy"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-currency-field-rw
                            :label    = "$t('contract.esc.phoneCosts')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.phoneCosts"
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                        <f-currency-field-rw
                            :label    = "$t('contract.esc.guardCosts')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.guardCosts"
                        />
                    </v-col>
                </v-row>
            </template>
        </c-site-contract-flip-card>

        <div
            v-if  = "!contractValid"
            class = "w-100 h-100"
        >
            <c-column-header
                label = "Notruf (kein Vertrag)"
                class = "primary mb-1 w-100"
            />
            <div class  = "lm-border mb-1 w-100" style="height: calc(100% - 29px)">

            </div>
        </div>
    </div>
</template>

<script>

import CSiteContractFlipCard from "@/modules/msd/company/contract/components/controls/common/CSiteContractFlipCard.vue";
import CColumnHeader         from "@/modules/core/components/utils/CColumnHeader.vue";
import SiteContractMixin     from "@/modules/msd/company/contract/components/controls/common/SiteContractMixin";
import FCurrencyFieldRw      from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import FTitle                from "@/modules/core/components/utils/FTitle.vue";
import FEnumSelectRw from "@/modules/core/components/utils/FEnumSelectRw.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";

export default {
    name: "CSiteContractEsc",

    mixins: [
        SiteContractMixin
    ],

    components: {
        FEnumSelectRw,
        FTitle,
        FCurrencyFieldRw,
        CColumnHeader,
        CSiteContractFlipCard,
    },

    props: {
        contract: {
            required: true,
            type    : Object
        },
        unit: {
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveEsc(this.unitId, this.contract.id,{
                start      : this.contract.unit.start,
                end        : this.contract.unit.end,
                costs      : this.contract.unit.costs,
                guardCosts : this.contract.unit.guardCosts,
                phoneCosts : this.contract.unit.phoneCosts,
                standBy    : this.contract.unit.standBy,
                rent       : this.contract.unit.rent,
                gadget     : this.contract.unit.gadget,
            }).then(() => {
                Core.message.hint(this, this.$t('contract.edit.stored'));
            })
        }
    }
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}


</style>